module.exports = __webpack_public_path__ + "static/media/shell32_7.6121f75c.ico";